module.exports = __webpack_public_path__ + "static/media/4inarow.d10b9ad2.png";